import React from 'react';
import cn from 'classnames';

import { Section, AnchorArrow } from 'react-scale/components';

const InstancesPerLabel = ({ title, items, background, smallNumbers, link }) => (
  <Section>
    <div className="text-center">
      <h3 className="mb-10 text-3xl">{title}</h3>
    </div>
    <div className="grid grid-cols-2 py-10 md:grid-cols-4 gap-y-16" style={{ background }}>
      {items.map(item => (
        <div key={item.label}>
          <div className="my-4 text-center">
            <span
              className={cn('text-white text-4xl lg:text-5xl xl:text-7xl block font-extra-light', {
                'lg:text-4xl xl:text-6xl': smallNumbers
              })}
            >
              {item.instances}
            </span>
            <p>
              <span className="block overflow-hidden whitespace-nowrap text-ellipsis">
                {item.label}
              </span>
            </p>
          </div>
        </div>
      ))}
    </div>
    {link && (
      <div className="mt-4 text-center">
        <AnchorArrow href={link.href} text={link.text} />
      </div>
    )}
  </Section>
);

InstancesPerLabel.defaultProps = {
  title: 'Instances Per Label',
  background: 'transparent',
  sectionTopPadding: false, // for section padding
  smallNumbers: false, // for smaller numbers
  link: null
};

export default InstancesPerLabel;
